import htmx from "htmx.org";
import "@htmx-ext/push-session-ext";
window.htmx = htmx;
import "htmx-ext-response-targets";
